import React, { useState } from 'react';
import { createEmployee, updateEmployee, updateOrder } from './operations';

const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export default function StaffSchedule({ employees, orders, customers, onRefresh }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [workDays, setWorkDays] = useState([]);
  const [workStart, setWorkStart] = useState('');
  const [workEnd, setWorkEnd] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [week, setWeek] = useState(new Date().toISOString().slice(0, 10));
  const [error, setError] = useState('');

  function toggleDay(day) {
    setWorkDays((current) => current.includes(day) ? current.filter((item) => item !== day) : [...current, day].sort());
  }

  function edit(person) {
    setEditingId(person.id);
    setName(person.name); setEmail(person.email); setPhone(person.phone);
    setWorkDays(person.work_days || []);
    setWorkStart(person.work_start?.slice(0, 5) || '');
    setWorkEnd(person.work_end?.slice(0, 5) || '');
  }

  function reset() {
    setEditingId(null);
    setName(''); setEmail(''); setPhone('');
    setWorkDays([]); setWorkStart(''); setWorkEnd('');
  }

  async function add(event) {
    event.preventDefault();
    setError('');
    if (workDays.length && (!workStart || !workEnd || workStart >= workEnd)) {
      setError('Choose a valid start and end time for scheduled days.');
      return;
    }
    try {
      const values = {
        name: name.trim(), email: email.trim(), phone: phone.trim(),
        work_days: workDays, work_start: workDays.length ? workStart : null,
        work_end: workDays.length ? workEnd : null
      };
      if (editingId) await updateEmployee(editingId, values);
      else await createEmployee(values);
      reset();
      await onRefresh();
    } catch (failure) {
      setError(failure.message);
    }
  }

  async function assign(orderId, employeeId) {
    try {
      await updateOrder(orderId, { employee_id: employeeId || null });
      await onRefresh();
    } catch (failure) {
      setError(failure.message);
    }
  }

  const start = new Date(`${week}T00:00:00`);
  const day = start.getDay();
  start.setDate(start.getDate() - day + (day === 0 ? -6 : 1));
  const days = Array.from({ length: 7 }, (_, index) => {
    const date = new Date(start);
    date.setDate(start.getDate() + index);
    return date;
  });

  return (
    <>
      <section className="crm-panel crm-feature"><div className="crm-panel-head"><h2>Employees & work time</h2></div>
        <form className="crm-feature-form" onSubmit={add}>
          <label>Name *<input required value={name} onChange={(event) => setName(event.target.value)} /></label>
          <label>Email<input type="email" value={email} onChange={(event) => setEmail(event.target.value)} /></label>
          <label>Phone<input value={phone} onChange={(event) => setPhone(event.target.value)} /></label>
          <fieldset className="crm-wide"><legend>Scheduled days</legend>{weekdays.map((label, index) => <label key={label} style={{ display: 'inline-flex', alignItems: 'center', margin: '8px 14px 8px 0', gap: 5 }}><input type="checkbox" checked={workDays.includes(index)} onChange={() => toggleDay(index)} />{label}</label>)}</fieldset>
          <label>Start time<input type="time" value={workStart} onChange={(event) => setWorkStart(event.target.value)} /></label>
          <label>End time<input type="time" value={workEnd} onChange={(event) => setWorkEnd(event.target.value)} /></label>
          <button type="submit">{editingId ? 'Save employee' : 'Add employee'}</button>
          {editingId && <button type="button" onClick={reset}>Cancel edit</button>}
        </form>
        {error && <p className="crm-error" role="alert">{error}</p>}
        <div className="crm-records">{employees.map((person) => <div className="crm-record" key={person.id}><div><strong>{person.name}</strong><small>{person.email} {person.phone}</small><small>{(person.work_days || []).map((day) => weekdays[day]).join(', ') || 'No scheduled days'}{person.work_start && ` · ${person.work_start.slice(0, 5)}–${person.work_end.slice(0, 5)}`}</small></div><small>{person.active ? 'Active' : 'Inactive'}</small><button onClick={() => edit(person)}>Edit schedule</button></div>)}</div>
      </section>
      <section className="crm-panel crm-feature"><div className="crm-panel-head"><div><h2>Worker schedule</h2><p>Scheduled work orders are grouped by local day.</p></div><input type="date" aria-label="Select week" value={week} onChange={(event) => setWeek(event.target.value)} /></div>
        <div className="crm-calendar">{days.map((date) => <div className="crm-calendar-day" key={date.toISOString()}><strong>{date.toLocaleDateString('en-SG', { weekday: 'short', day: 'numeric', month: 'short' })}</strong>
          {employees.filter((person) => person.active && (person.work_days || []).includes(date.getDay())).map((person) => <div className="crm-calendar-event" key={person.id}><strong>{person.name}</strong><small>{person.work_start?.slice(0, 5)}–{person.work_end?.slice(0, 5)}</small></div>)}
          {orders.filter((order) => order.scheduled_at && order.status !== 'Cancelled' && new Date(order.scheduled_at).toDateString() === date.toDateString()).map((order) => <div className="crm-calendar-event" key={order.id}><strong>{new Date(order.scheduled_at).toLocaleTimeString('en-SG', { hour: '2-digit', minute: '2-digit' })} · {order.service}</strong><small>{customers.find((item) => item.id === order.customer_id)?.name} · {order.duration_minutes} min</small><select aria-label="Assign employee" value={order.employee_id || ''} onChange={(event) => assign(order.id, event.target.value)}><option value="">Unassigned</option>{employees.map((person) => <option key={person.id} value={person.id}>{person.name}</option>)}</select></div>)}
        </div>)}</div>
      </section>
    </>
  );
}